import { render, staticRenderFns } from "./ChangePasswordTab.vue?vue&type=template&id=ddfbd944&"
import script from "./ChangePasswordTab.vue?vue&type=script&lang=js&"
export * from "./ChangePasswordTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports